import { render, staticRenderFns } from "./FichiersDocument.vue?vue&type=template&id=3bd8d172"
import script from "./FichiersDocument.vue?vue&type=script&lang=js"
export * from "./FichiersDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports